import styles from '../_signup.module.scss'
import { t } from '../../../utils/i18n'
import Link from 'next/link'
import Image from 'next/legacy/image'
import guitaristImg from '@public/images/guitarist.png'
import { Plan } from '../../../__generated__/graphql'

interface PlanProps {
  plan: Plan
  handleContinue: any
}

const Plan: React.FC<PlanProps> = ({ plan, handleContinue }) => (
  <div>
    <div className={styles.signupForm}>
      <div>
        <div className={styles.planDescription}>
          <p className={styles.planTitle}>{t('Description')}:</p>
          <p className={styles.planSubtitle}>{plan.description}</p>
        </div>
        <div className={styles.planPrice}>
          <p className={styles.planTitle}>{t('Price')}:</p>
          <p className={styles.planSubtitle}>
            ${plan.price}/{plan.isYearly ? t('year') : t('month')}
            &nbsp;{plan.price > 0 ? t('after free trial') : ''}
          </p>
        </div>
        <Link
          href="https://worshiponline.com/pricing/"
          prefetch={false}
          className={styles.planLink}
        >
          {t('Choose a different plan')}
        </Link>
      </div>
      <div className={styles.button} onClick={() => handleContinue()}>
        <span>{t('Continue')}</span>
      </div>
    </div>
    <div className={styles.signupPicture}>
      <Image alt="Guitarist" src={guitaristImg} height={535} width={696} />
    </div>
  </div>
)

export default Plan
